/**
 * @file   src\Pages\Locations.tsx
 * @brief  Locations page.
 * @date   JULY, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { React, useState, useNavigate, useParams } from "../utils/thirdpartyComponents"
import { Button } from "react-bootstrap";
import RadioButton from "src/components/RadioButton";
import { CommonMessages } from "src/messages/validationMessages";
import "src/styles/inner-page-styles.scss";
import { pageURLs } from 'src/utils/pageUrls';


const Locations = () => {
    const navigate = useNavigate();
    const params = useParams();
    const locationArray = [
        {
            "name": "Camps Car Wash",
            "location": "285, Amherst St."
        },
        {
            "name": "Camps Car Wash",
            "location": "86, Broad St."
        },
        {
            "name": "Camps Car Wash",
            "location": "487, Amherst St."
        },
        {
            "name": "Camps Car Wash",
            "location": "607, Amherst St"
        },
        {
            "name": "Camps Car Wash",
            "location": "607, Amherst St"
        },
        {
            "name": "Camps Car Wash",
            "location": "607, Amherst St"
        },
        {
            "name": "Camps Car Wash",
            "location": "607, Amherst St"
        },
        {
            "name": "Camps Car Wash",
            "location": "607, Amherst St"
        },
        {
            "name": "Camps Car Wash",
            "location": "607, Amherst St"
        },
    ]

    // Initialise state for list of locations
    const [locations, setLocations] = useState(locationArray)

    // State to handle selected location
    const [selectedLocation, setSelectedLocation] = useState<string | null>(null)

    // Initialize state for errors
    const [error, setError] = useState<string | null>(null)

    // Function to handle radio button selection
    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setError(null)
        setSelectedLocation(event.target.value);
    };

    // Function to handle OK button click
    const handleOkButtonClick = () => {
        if (selectedLocation) {
            navigate("/"+params.carwashname+"/"+pageURLs.home)
        } else {
            setError(CommonMessages.location_required)
        }
    };


    return (

        <div className="common-content-wrap pb-115">
            <div className="inner-content-wrap signup-block">
                <div className="common-header">
                    <div className="pe-4 ps-4 pt-0 pb-0 h-100">
                        <div className="common-header-inner">Select Wash Location</div>
                    </div>
                </div>

                {/* <LocationList locations={locations} handleRadioChange={handleRadioChange} /> */}
                <div className="main-content-wrap pe-0 ps-0 pt-0">
                    {
                        locations.map((location, index) => (
                            <div key={index} className="location-info-card">
                                <RadioButton name={"select_location"} label={location.name} value={location.location} onChange={handleRadioChange} />
                            </div>
                        ))
                    }
                </div>
            </div>

            <div className="btm-wrap">
                <div className="btm-inner-wrap">
                    {error ? <span className="error-msg">{error}</span> : null}
                    <Button variant="primary" className="primary-btn btn-main" onClick={handleOkButtonClick}>OK</Button>
                </div>
            </div>
        </div>
    )
}

export default Locations;
